"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostTransport = void 0;
var PostTransport = /** @class */ (function () {
    function PostTransport(url) {
        this.url = url;
    }
    PostTransport.prototype.send = function (data) {
        this.sendPostRequest(JSON.stringify(data));
    };
    PostTransport.prototype.sendPostRequest = function (data) {
        var request = new XMLHttpRequest();
        request.open('POST', this.url);
        request.setRequestHeader('Content-Type', 'text/plain;charset=UTF-8');
        request.send(data);
    };
    return PostTransport;
}());
exports.PostTransport = PostTransport;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUG9zdFRyYW5zcG9ydC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIlBvc3RUcmFuc3BvcnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUE7SUFDSSx1QkFBNkIsR0FBVztRQUFYLFFBQUcsR0FBSCxHQUFHLENBQVE7SUFBRyxDQUFDO0lBQ3JDLDRCQUFJLEdBQVgsVUFBWSxJQUFvQztRQUM1QyxJQUFJLENBQUMsZUFBZSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQztJQUMvQyxDQUFDO0lBRU8sdUNBQWUsR0FBdkIsVUFBd0IsSUFBWTtRQUNoQyxJQUFNLE9BQU8sR0FBRyxJQUFJLGNBQWMsRUFBRSxDQUFDO1FBQ3JDLE9BQU8sQ0FBQyxJQUFJLENBQUMsTUFBTSxFQUFFLElBQUksQ0FBQyxHQUFHLENBQUMsQ0FBQztRQUMvQixPQUFPLENBQUMsZ0JBQWdCLENBQUMsY0FBYyxFQUFFLDBCQUEwQixDQUFDLENBQUM7UUFDckUsT0FBTyxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUN2QixDQUFDO0lBQ0wsb0JBQUM7QUFBRCxDQUFDLEFBWkQsSUFZQztBQVpZLHNDQUFhIn0=